import { useEffect, useState } from "react";
import api from "../../utils/api";

export default function Analytics() {
  const [stats, setStats] = useState({
    totalViews: 0,
    videoViews: 0,
    shortsViews: 0,
    postViews: 0,
    songViews: 0,
    totalVideos: 0,
    totalShorts: 0,
    totalPosts: 0,
    totalSongs: 0,
  });

  const [loading, setLoading] = useState(true);

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const channelId = user?.channelId;
  const userId = user?._id;

  useEffect(() => {
    if (!channelId || !userId) return;

    const loadStats = async () => {
      try {
        /* -------- Channel Videos & Shorts -------- */
        const channelRes = await api.get(
          "/client/user/detailsOfChannel",
          {
            params: {
              channelId,
              userId,
              start: 1,
              limit: 500,
            },
          }
        );

        const allVideos =
          channelRes?.data?.status
            ? channelRes.data.detailsOfChannel || []
            : [];

        const onlyVideos = allVideos.filter(
          (v) => v.videoType === 1
        );

        const onlyShorts = allVideos.filter(
          (v) => v.videoType === 2
        );

        const videoViews = onlyVideos.reduce(
          (sum, v) => sum + (v.views || 0),
          0
        );

        const shortsViews = onlyShorts.reduce(
          (sum, v) => sum + (v.views || 0),
          0
        );

        /* -------- Channel Posts -------- */
        const postRes = await api.get(
          "/client/posts/channel-posts",
          {
            params: { channelId },
          }
        );

        const posts =
          postRes?.data?.status
            ? postRes.data.postsOfChannel || []
            : [];

        const postViews = posts.reduce(
          (sum, p) => sum + (p.viewsCount || 0),
          0
        );

        /* -------- Channel Songs -------- */
        const songRes = await api.get(
          "/client/song/songsOfChannel",
          {
            params: { channelId },
          }
        );

        const songs =
          songRes?.data?.status
            ? songRes.data.songs || []
            : [];

        const songViews = songs.reduce(
          (sum, s) => sum + (s.totalPlays || 0),
          0
        );

        const totalViews =
          videoViews +
          shortsViews +
          postViews +
          songViews;

        setStats({
          totalViews,
          videoViews,
          shortsViews,
          postViews,
          songViews,
          totalVideos: onlyVideos.length,
          totalShorts: onlyShorts.length,
          totalPosts: posts.length,
          totalSongs: songs.length,
        });

      } catch (err) {
        console.error("Analytics load error:", err);

        setStats({
          totalViews: 0,
          videoViews: 0,
          shortsViews: 0,
          postViews: 0,
          songViews: 0,
          totalVideos: 0,
          totalShorts: 0,
          totalPosts: 0,
          totalSongs: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, [channelId, userId]);

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num;
  };

  if (loading)
    return <p className="panel-loading">Loading analytics...</p>;

  return (
    <div className="panel-container">
      <h2>Analytics Overview</h2>

      <div className="stats-grid">

        <div className="stat-card">
          <h3>Total Views</h3>
          <p>{formatNumber(stats.totalViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Video Views</h3>
          <p>{formatNumber(stats.videoViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Shorts Views</h3>
          <p>{formatNumber(stats.shortsViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Post Views</h3>
          <p>{formatNumber(stats.postViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Song Plays</h3>
          <p>{formatNumber(stats.songViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Total Videos</h3>
          <p>{stats.totalVideos}</p>
        </div>

        <div className="stat-card">
          <h3>Total Shorts</h3>
          <p>{stats.totalShorts}</p>
        </div>

        <div className="stat-card">
          <h3>Total Posts</h3>
          <p>{stats.totalPosts}</p>
        </div>

        <div className="stat-card">
          <h3>Total Songs</h3>
          <p>{stats.totalSongs}</p>
        </div>

      </div>
    </div>
  );
}